export const baseURL = {
    development: 'https://dev-apaas.grtcloud.net/api',
    test: 'https://test-apaas.grtcloud.net/api',
    production: 'https://apaas.grtcloud.net/api',
    local: 'http://127.0.0.1:4523/m1/1606492-0-4e213591'
}[process.env.REACT_APP_MODE];

export const loginURL = {
    development: 'https://dev-passport.grtcloud.net/',
    test: 'https://test-passport.grtcloud.net/',
    production: 'https://passport.grtcloud.net/',
    local: 'https://dev-passport.grtcloud.net/'
}[process.env.REACT_APP_MODE];

export const staticUrl = {
    development: 'https://test-lowcode.grtcloud.net/static_main',
    test: 'https://test-lowcode.grtcloud.net/static_main',
    production: 'https://lowcode.grtcloud.net/static_main'
}[process.env.REACT_APP_MODE];

export const xygsURL = {
    development: 'https://test.ttcdw.com.cn',
    test: 'https://test.ttcdw.com.cn',
    production: 'https://www.ttcdw.com.cn',
    local: 'https://test.ttcdw.com.cn'
}[process.env.REACT_APP_MODE];

const URL = {
    lowcodeget: baseURL + '/lowcodeget',
    assetJson: staticUrl + '/assets.json',
    getVersion: baseURL + '/apaas-system-service/webpage/v1/lastest'
};

export const apaasURL = {
    development: 'https://dev-apaas.grtcloud.net/api',
    test: 'https://test-apaas.grtcloud.net/api',
    production: 'https://apaas.grtcloud.net/api',
    local: 'http://127.0.0.1:4523/m1/1606492-0-4e213591'
}[process.env.REACT_APP_MODE];

export default URL;
